// extracted by mini-css-extract-plugin
export default {"container":"StarRate_container__sxc-u","ratingStar":"StarRate_ratingStar__DlTZ8"};